import { Reducer } from 'redux';

// Actions

export const updateWebsocketState = (connected: boolean) => ({
  type: 'UPDATE_WEBSOCKET_STATE' as const,
  connected,
});

export const updateOrderbookWebsocketState = (connected: boolean) => ({
  type: 'UPDATE_ORDERBOOK_WEBSOCKET_STATE' as const,
  connected,
});

type WebsocketStateAction = ReturnType<
  typeof updateWebsocketState | typeof updateOrderbookWebsocketState
>;

// Reducer

interface WebsocketState {
  connected?: boolean;
  orderbookConnected?: boolean;
}

export const websocketStateReducer: Reducer<
  WebsocketState,
  WebsocketStateAction
> = (
  state = { connected: undefined, orderbookConnected: undefined },
  action
): WebsocketState => {
  switch (action.type) {
    case 'UPDATE_WEBSOCKET_STATE':
      return {
        ...state,
        connected: action.connected,
      };
    case 'UPDATE_ORDERBOOK_WEBSOCKET_STATE':
      return {
        ...state,
        orderbookConnected: action.connected,
      };
    default:
      return state;
  }
};
